module.exports = __webpack_public_path__ + "static/media/CT-logo.c6116107.svg";